























































import { Component, Prop, Emit, Vue } from "vue-property-decorator";
import CircleComponent from "@/components/common/figures/CircleComponent.vue";
import InputCheckboxComponent from "@/components/common/input/InputCheckboxComponent.vue";
import {
  CategorySideMenuSensor,
  CategorySideMenuIcon
} from "@/typescript/components/common/layout/category_side_menu_component/types";
import { getEquipmentIcon } from "../../typescript/lib/common/get_equipment_icon";
import { GetStoreSensorsResponseSensor } from "@/typescript/api_client/emesh_api/stores/types";
export {
  GetStoreSensorsResponseSensor,
  CategorySideMenuSensor,
  CategorySideMenuIcon
};

@Component({
  components: {
    CircleComponent,
    InputCheckboxComponent
  }
})
export default class CategorySideMenuComponent extends Vue {
  @Prop()
  categorySideMenuSensors!: CategorySideMenuSensor[];

  @Prop()
  storeSensors!: GetStoreSensorsResponseSensor[];

  // グラフなどで凡例の色表示が必要ならtrueを指定
  @Prop({
    default: false
  })
  shouldRegend!: boolean;

  @Prop()
  sensorIcons!: CategorySideMenuIcon[];

  @Prop({
    default: false
  })
  hasData!: boolean;

  selectedEquipmentIds: string[] = [];

  @Emit()
  onCheck(sensor: CategorySideMenuSensor, event): CategorySideMenuSensor {
    sensor.isChecked = event.target.checked;
    return sensor;
  }

  @Emit()
  onClickIcon(icon: CategorySideMenuIcon) {
    return icon;
  }

  isSelectedEquipmentId(equipmentId: string): boolean {
    return this.selectedEquipmentIds.some(id => id === equipmentId);
  }

  getEquipmentIcon(iconKind: number, status: "on" | "off"): string {
    return getEquipmentIcon(iconKind, status);
  }
}
